import { useState } from 'react'

export function useEditMode() {
  const [isEditMode, setIsEditMode] = useState(false)

  return {
    isEditMode,
    startEditing: () => setIsEditMode(true),
    stopEditing: () => setIsEditMode(false),
  }
}
